export default __webpack_public_path__ + "static/media/search.f326cfeb.svg";